import { useParams, Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const CONTENT = {
  faq: {
    title: "Frequently Asked Questions",
    sections: [
      ["What are Merari candles made of?", "Every Merari candle is hand-poured using 100% soy wax with a lead-free cotton wick, in a clear glass vessel with a gold lid."],
      ["How long will my candle burn?", "Our 9 oz signature pour burns for approximately 55-65 hours when cared for properly."],
      ["How should I care for my candle?", "On the first burn, let the melt pool reach the edge of the vessel. Trim the wick to 1/4 inch before each lighting, and never leave a burning candle unattended."],
      ["Can I create a custom scent?", "Yes — visit Create Your Scent and tell us what you love. We'll help you craft a soy wax candle that's uniquely yours."],
      ["Do you offer candles for events?", "We do. The Merari Candle Experience brings mobile candle-making to your event, and our custom favors are made especially for weddings, showers, and celebrations of every kind."],
      ["Where are Merari candles made?", "Every candle is hand-poured in small batches in Manayunk, Philadelphia."],
    ],
  },
  shipping: {
    title: "Shipping Policy",
    sections: [
      ["Processing Time", "Each candle is hand-poured to order. Please allow 3-5 business days for your order to be poured, cured, and prepared for shipment."],
      ["Shipping Rates", "Shipping rates are calculated at checkout based on your location and order size."],
      ["Delivery", "Orders ship via tracked carriers. You'll receive tracking details by email as soon as your candles are on their way."],
      ["Warm Weather Note", "Soy wax is sensitive to high heat. During warmer months, we recommend bringing your package indoors promptly after delivery."],
    ],
  },
  returns: {
    title: "Return Policy",
    sections: [
      ["Returns", "Unburned candles in original condition may be returned within 14 days of delivery. Custom scent creations and personalized favors are made just for you and are final sale."],
      ["Damaged Orders", "If your candle arrives damaged, contact us within 7 days with a photo and we'll make it right — replacement or refund."],
      ["How to Start a Return", "Reach out through our Contact page with your order details and we'll guide you through the process."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["What We Collect", "We collect the information you share with us — your name, contact details, and order information — solely to fulfill orders and respond to your inquiries."],
      ["How It's Used", "Your information is used to process orders, craft your custom requests, and communicate with you. Payment details are processed securely by our payment provider and are never stored on our servers."],
      ["Your Choices", "You may request to view or delete your personal information at any time by contacting us."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    sections: [
      ["Our Products", "Merari candles are hand-poured in small batches; slight variations in appearance are part of their handmade character. Burn candles within sight, away from drafts, children, and pets."],
      ["Orders & Payment", "Orders are confirmed once payment is completed through our secure checkout. Prices are listed in USD."],
      ["Custom Work", "Custom scents, labels, and favors are quoted individually. Production timelines are confirmed at booking."],
      ["Contact", "Questions about these terms? Reach us through the Contact page."],
    ],
  },
};

const Policy = () => {
  const { slug } = useParams();
  const page = CONTENT[slug] || CONTENT.faq;

  return (
    <div data-testid={`policy-page-${slug}`} className="bg-ivory min-h-[60vh]">
      <section className="border-b border-line py-14 md:py-20 text-center">
        <Reveal>
          <p className="eyebrow">Merari Candle Company</p>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl font-light tracking-tight">{page.title}</h1>
        </Reveal>
      </section>
      <section className="mx-auto max-w-3xl px-6 sm:px-12 py-14 md:py-20">
        {page.sections.map(([q, a], i) => (
          <Reveal key={q} delay={i * 0.05} className="border-b border-line py-8 first:pt-0">
            <h2 className="font-serif text-2xl font-light tracking-tight">{q}</h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-stone2">{a}</p>
          </Reveal>
        ))}
        <Reveal className="pt-10 text-center">
          <Link to="/contact" data-testid="policy-contact-link" className="btn-outline">Still Have a Question?</Link>
        </Reveal>
      </section>
    </div>
  );
};

export default Policy;
